/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, DatePicker } from "antd";
import { Table, Button, Input, Select, Space, Upload, Spin } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import Axios from "../../../api/Axios";
import { CloseOutlined, FormOutlined, CaretUpOutlined } from "@ant-design/icons";
const { Option } = Select;
const EditSub = ({
  record,
  CreateSuccessfull,
  CreateFailed,
  billings,
  subscription,
  category,
  enrollments,
  onCancel,
  visible,
}) => {
  useEffect(() => {
    setSelectedBillingCycle(record?.billing_cycle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //console.log(record.application);
  //console.log(record.start_date);
  const myDayjsDate = dayjs(record.start_date, "YYYY-MM-DD");
  //console.log(myDayjsDate);
  const testDate = myDayjsDate.add(1, "year");
  //console.log(testDate);
  const handleCancel = () => {
    onCancel();
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const renderApplication = () => {
    switch (record.application) {
      case "Trak Learning":
        return 1;
      case "Trak Coaching":
        return 2;
      case "DelegateHR":
        return 3;
      default:
        return null;
    }
  };
  const onFinish = async (values) => {
    //console.log(values);
    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(
        ([_, value]) => value !== undefined && value !== null
      )
    );
    const startDate = dayjs(values.start_date);
    const endDate = dayjs(values.end_date);
    const payload = {
      ...filteredValues,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: record.organization,
      application: renderApplication(),
    };
    //console.log(payload);
    try {
      const res = await Axios.put(`/orgsubscription/${record.id}/`, payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      CreateSuccessfull("edited");
    } catch (err) {
      //console.log(err);
      CreateFailed("edited");
    }
  };

  const checkEnrollment = () => {
    //console.log(record?.application);
    if (
      record?.application === "Trak Learning" ||
      record?.application === "Trak Coaching"
    ) {
      return false;
    } else {
      return true;
    }
  };
  const [form] = Form.useForm();
  const [selectedBillingCycle, setSelectedBillingCycle] = useState(null);
  const handleBillingCycleChange = (value) => {
    setSelectedBillingCycle(value);
    form.setFieldsValue({
      end_date: null, // Reset the end date when the billing cycle changes
    });
  };

  const handleStartDateChange = (date) => {
    const startDate = dayjs(date, "YYYY-MM-DD");
    //console.log(startDate);
    let endDate = null;

    if (selectedBillingCycle === "annually") {
      endDate = startDate.add(1, "year");
    } else if (selectedBillingCycle === "quarterly") {
      endDate = startDate.add(3, "month");
    } else if (selectedBillingCycle === "monthly") {
      endDate = startDate.add(1, "month");
    }
    //console.log(endDate);

    form.setFieldsValue({
      end_date: dayjs(endDate, "YYYY-MM-DD"), // Set the calculated end date based on the start date and billing cycle
    });
  };

  return (
    <Modal
      // title="My Modal"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      title={<p className="modal-heading">EDIT SUBSCRIPTION DETAILS</p>}
      centered
      width={1200}
    >
      <Form
        name="complex-form"
        onFinish={onFinish}
        layout="vertical"
        // ref={formRef}
        form={form}
        initialValues={{
          start_date: dayjs(record.start_date, "YYYY-MM-DD"),
          end_date: dayjs(record.end_date, "YYYY-MM-DD"),
        }}
        labelCol={{
          span: 14,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          Width: "100%",
        }}
      >
        <div className="group1" style={{ padding: "0rem" }}>
          <div className="group-1-box">
            <div style={{ display: "inline-block" }}>
              <Form.Item label={<p className="my-form-lables">Module</p>}>
                <Space>
                  <Form.Item
                    name="application"
                    initialValue={record?.application}
                  >
                    <Input
                      placeholder="Application"
                      name="application"
                      className="my-form-input"
                      style={{ width: "26rem", opacity: 1, color: "black" }}
                      disabled
                    />
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item label={<p className="my-form-lables">Contract ID</p>}>
                <Space>
                  <Form.Item
                    name="contract_id"
                    initialValue={record?.contract_id}
                  >
                    <Input
                      placeholder="Contract id"
                      name="contract_id"
                      className="my-form-input"
                      style={{ width: "26rem" }}
                    />
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item
                label={<p className="my-form-lables">Enrollment type</p>}
              >
                <Space>
                  <Form.Item
                    name="enrollment_type"
                    initialValue={record?.enrollment_type}
                  >
                    <Select
                      placeholder="Enrollment Type"
                      name="enrollment_type"
                      className="my-form-input"
                      style={{ width: "26rem" }}
                      disabled={checkEnrollment()}
                    >
                      {enrollments?.enrollment_type?.map((app) => (
                        <Option key={app} value={app}>
                          {app}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item
                label={<p className="my-form-lables">Billing Cycle</p>}
              >
                <Space>
                  <Form.Item
                    name="billing_cycle"
                    initialValue={record?.billing_cycle}
                  >
                    <Select
                      placeholder="Billing"
                      name="billing_cycle"
                      className="my-form-input"
                      style={{ width: "26rem" }}
                      onChange={handleBillingCycleChange}
                    >
                      {billings?.billing_cycle?.map((app) => (
                        <Option key={app} value={app}>
                          {app}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
          </div>
          <div className="group-1-box" style={{ paddingTop: "1rem" }}>
            <div style={{ display: "inline-block" }}>
              <Form.Item
                label={<p className="my-form-lables">Subscription Type</p>}
              >
                <Space>
                  <Form.Item
                    name="subscription_type"
                    initialValue={record?.subscription_type}
                  >
                    <Select
                      placeholder="Subscription Type"
                      name="subscription_type"
                      className="my-form-input"
                      style={{ width: "26rem" }}
                    >
                      {subscription?.subscription_type?.map((app) => (
                        <Option key={app} value={app}>
                          {app}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item label={<p className="my-form-lables">Category</p>}>
                <Space>
                  <Form.Item
                    name="subscription_category"
                    initialValue={record?.subscription_category}
                  >
                    <Select
                      placeholder="Category"
                      name="subscription_category"
                      className="my-form-input"
                      style={{ width: "26rem" }}
                    >
                      {category?.subscription_category?.map((app) => (
                        <Option key={app} value={app}>
                          {app}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>

            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item label={<p className="my-form-lables">Start Date</p>}>
                <Space>
                  <Form.Item
                    name="start_date"
                    // className="my-form-input"
                    // style={{ width: "26rem" }}
                  >
                    <DatePicker
                      format={"YYYY-MM-DD"}
                      className="my-form-input"
                      style={{ width: "26rem" }}
                      onChange={handleStartDateChange}
                    />
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
            <div style={{ display: "inline-block", marginLeft: "2rem" }}>
              <Form.Item label={<p className="my-form-lables">End Date</p>}>
                <Space>
                  <Form.Item
                    name="end_date"
                    // className="my-form-input"
                    // style={{ width: "26rem" }}
                  >
                    <DatePicker
                      format={"YYYY-MM-DD"}
                      className="my-form-input"
                      style={{ width: "26rem" }}
                      disabled={!selectedBillingCycle}
                    />
                  </Form.Item>
                </Space>
              </Form.Item>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            height: "2rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Form.Item style={{ marginRight: "1rem" }}>
            <Button key="back" onClick={handleCancel}>
              <CloseOutlined />
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#f58029",
                fontWeight: "600",
              }}
              className="save-update-btn"
            >
              Update
              <FormOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default EditSub;
